import ReactDOM from "react-dom";
import { Button } from "devextreme-react/button";

const modalRoot = document.getElementById("modal-root");

const Dialog = ({ title, isOpen, onClose, children }) => {
  if (!isOpen) return null;
  return ReactDOM.createPortal(
    <div className="dialog ">
      <div className="dialog-content dx-theme-background-color">
        <div className="absolute top-1 right-1">
          <Button icon="close" stylingMode="text" onClick={onClose} />
        </div>

        <h6 className="mb-2 dx-theme-text-color">{title}</h6>
        <hr />
        {children}
      </div>
    </div>,
    modalRoot
  );
};

export default Dialog;

export const ConfirmDialog = ({
  title,
  message,
  isOpen,
  setIsOpen,
  onSuccess,
  data,
}) => {
  return (
    <Dialog title={title} isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <div className="my-2">
        <span className="dx-theme-text-color">{message}</span>
      </div>
      <div className="flex  items-center justify-end">
        <Button
          stylingMode="text"
          text="Tidak"
          onClick={() => setIsOpen(false)}
          className="m-2"
        />
        <Button
          stylingMode="contained"
          type="danger"
          text="IYA"
          className="m-2"
          onClick={() => onSuccess(data)}
        />
      </div>
    </Dialog>
  );
};
